import { render } from "./DialogModificaCompletamento.vue?vue&type=template&id=c6820aa6"
import script from "./DialogModificaCompletamento.vue?vue&type=script&lang=js"
export * from "./DialogModificaCompletamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__